export type AddressSearchOperation = 'search' | 'drilldown' | 'retrieve';
